import BrandsApi from '../../apis/Brands';

export default {
    namespaced: true,
    state: {
        brands: [],
        brand_response: null
    },
    mutations: {
        set_brands (state, data) {
            state.brands = data;
        },
        set_brand_response (state, value) {
            state.brand_response = value;
        }
    },
    actions: {
        async getBrands({commit, dispatch}, filters) {
            commit('set_brand_response', null);
            return await BrandsApi.get_all(filters)
                .then( response => {
                    commit('set_brands', response.data)
                })
                .catch( error => {
                    commit('set_brand_response', 'error');
                })
        },
        async store({commit, dispatch}, brand) {
            commit('set_brand_response', null);
            return await BrandsApi.store(brand)
                .then( response => {
                    commit('set_brand_response', 'success');
                    dispatch('getBrands');
                })
                .catch( error => {
                    commit('set_brand_response', 'error');
                })
        },
        async update({commit, dispatch}, brand) {
            commit('set_brand_response', null);
            return await BrandsApi.update(brand)
                .then( response => {
                    commit('set_brand_response', 'success');
                    dispatch('getBrands')
                })
                .catch( error => {
                    commit('set_brand_response', 'error');
                })
        },
        async change_status({commit, dispatch}, brand) {
            commit('set_brand_response', null);
            return await BrandsApi.change_status(brand)
                .then( response => {
                    commit('set_brand_response', 'success');
                    dispatch('getBrands')
                })
                .catch( error => {
                    commit('set_brand_response', null);
                })
        },
    }
}